import { useParams, useNavigate } from 'react-router-dom';
import { useCatalog } from '../hooks/useApi';
import { TopBar, Breadcrumb, ImageFB, ModelListSkeleton, EmptyState, ErrorState, formatPrice } from '../components';

export function BrandDetail() {
  const { brandId } = useParams<{ brandId: string }>();
  const navigate = useNavigate();
  const { data, loading, error, refetch } = useCatalog();

  const brand = data?.brands.find((b) => b.id === brandId) ?? null;

  return (
    <div>
      <TopBar title={brand?.name} showBack />
      <Breadcrumb items={[
        { label: 'Home', to: '/' },
        { label: brand?.name || '...' },
      ]} />

      {loading ? (
        <ModelListSkeleton />
      ) : error ? (
        <ErrorState msg={error} onRetry={refetch} />
      ) : brand && brand.models.length > 0 ? (
        <div className="model-list">
          {brand.models.map((model) => (
            <div
              key={model.id}
              className="model-card"
              onClick={() => navigate(`/brand/${brandId}/model/${model.id}`)}
            >
              <div className="thumb">
                <ImageFB src={model.coverUrl} alt={model.code} />
              </div>
              <div className="info">
                {/* ERP 的型号只有编码（没有独立中文名与徽章），这里只展示编码与价格 */}
                <div className="name">{model.code}</div>
                <div style={{ flex: 1 }} />
                <div className="price-row">
                  <span className="label">Price:</span>
                  <span className="price">{formatPrice(model.price)}</span>
                  <span className="currency">MMK</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState title="Not listed yet" desc="Check back soon" />
      )}

      <div style={{ height: 40 }} />
    </div>
  );
}
